import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProgramPage = lazy(() => import('../pages/program/page'));
const GeneralInfoPage = lazy(() => import('../pages/genel-bilgiler/page'));
const ContactPage = lazy(() => import('../pages/iletisim/page'));
const RegistrationPage = lazy(() => import('../pages/kayit/page'));
const RegistrationFullPage = lazy(() => import('../pages/kayit-doldu/page'));
const CoursesPage = lazy(() => import('../pages/kurslar/page'));
const ImportantDatesPage = lazy(() => import('../pages/onemli-tarihler/page'));
const SpeakersPage = lazy(() => import('../pages/konusmacılar/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/program',
    element: <ProgramPage />,
  },
  {
    path: '/genel-bilgiler',
    element: <GeneralInfoPage />,
  },
  {
    path: '/kurslar',
    element: <CoursesPage />,
  },
  {
    path: '/onemli-tarihler',
    element: <ImportantDatesPage />,
  },
  {
    path: '/kayit',
    element: <RegistrationPage />,
  },
  {
    path: '/kayit-doldu',
    element: <RegistrationFullPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/konusmacılar',
    element: <SpeakersPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
